import React, { useContext, useState, useEffect } from 'react';

import { Context } from '@store/store';

import { StyledFooter, LowerWrapper } from './footer.styles';

import ProgressBar from './progress-bar';
import FooterButtons from './footer-buttons';

const Footer = ({ pagesCount }) => {
  const [state, dispatch] = useContext(Context);
  const [localizedCurrentPage, setLocalizedCurrentPage] = useState(
    state.currentPage,
  );

  const setLocalize = (e) => {
    let currentPage = e;
    if (!state.isSinglePageMode) {
      currentPage = e * 2;
    }
    setLocalizedCurrentPage(currentPage)
  }

  useEffect(() => {
    setLocalizedCurrentPage(parseInt(state.currentPage));
  }, [state.isSinglePageMode, state.currentPage]);

  return (
    <StyledFooter>

      <ProgressBar
        totalPages={pagesCount}
        localizedCurrentPage={localizedCurrentPage}
        setLocalize={setLocalize}
      />
      <LowerWrapper>
        <div />
        {state.isSinglePageMode ? (
          <span>Страница {parseInt(localizedCurrentPage) + 1}</span>
        ) : (
          <span>
            {parseInt(localizedCurrentPage) === 0
              ? `Страница 1`
              : (parseInt(localizedCurrentPage)) >= pagesCount - 1 &&
                (pagesCount) % 2 === 0
              ? `Страница ${pagesCount}`
              : `Страницы ${parseInt(localizedCurrentPage)}–${
                  parseInt(localizedCurrentPage) + 1
                }`}
          </span>
        )}
        <span>{pagesCount}</span>
      </LowerWrapper>
    </StyledFooter>
  );
};

export default Footer;
